import React, { useRef, useState } from "react";
import Input from "./Input";
import { db, uploadFile } from "../../FirebaseConfig.ts";
import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import Spinner from "../../components/Spinner";
import { useParams } from "react-router-dom";
import useUpdateDoc from "../../hooks/useUpdateDoc.js";

function FormStepTwo({
  setActiveMoney,
  activeMoney,
  setStep,
  data,
  setData,
  files,
  setFiles,
  dataCodeudor,
}) {
  const form = useRef();

  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sended, setSended] = useState(false);

  const { handleUpdate } = useUpdateDoc();

  const sendCredit = async (e) => {
    e.preventDefault();

    setLoading(true);
    //sube el archivo a firebase

    const name = `${dataCodeudor.name}`;

    try {
      const uploadPromises = Object.keys(files).map(async (key) => {
        const file = files[key];

        if (file) {
          // Solo subimos si el archivo está presente
          const url = await uploadFile(file, `${name}/${key}`);
          return { [key]: url }; // Retornamos un objeto con el nombre del archivo como clave
        }
        return null;
      });

      const uploadResults = await Promise.all(uploadPromises);

      // Convertir los resultados en un objeto de URLs
      const fileUrls = uploadResults.reduce((acc, curr) => {
        if (curr) {
          return { ...acc, ...curr };
        }
        return acc;
      }, {});

      handleUpdate("codeudor", id, {
        ...fileUrls,
      });

      setData({
        identity: "",
        expedition: "",
      });
      setFiles({
        cert_laboral: "",
        comp_nomina: "",
        fot_cedula: "",
        dec_renta: "",
      });
      setError("");
      setSended(true);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
      setError(
        "Ha ocurrido un error al mandar la solicitud, por favor intente nuevamente"
      );
      setSended(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={() => {
          setStep(0);
          setActiveMoney(activeMoney);
        }}
      >
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 12H4M4 12L10 6M4 12L10 18"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <form className="w-full mx-auto" ref={form} onSubmit={sendCredit}>
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5">
          <Input
            label="Cédula"
            onChange={(e) => {
              setData({ ...data, identity: e.target.value });
            }}
            value={data.identity}
          />

          <Input
            label="Lugar de Expedición"
            onChange={(e) => {
              setData({ ...data, expedition: e.target.value });
            }}
            value={data.expedition}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5">
          <Input
            label="Certificación Laboral"
            type="file"
            onChange={(e) => {
              setFiles({ ...files, cert_laboral: e.target.files[0] });
            }}
            accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          />
          <Input
            label="Comprobante de nómina"
            type="file"
            onChange={(e) => {
              setFiles({ ...files, comp_nomina: e.target.files[0] });
            }}
            accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5">
          <Input
            label="Fotocopia de la cédula"
            type="file"
            onChange={(e) => {
              setFiles({ ...files, fot_cedula: e.target.files[0] });
            }}
            accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          />
          <Input
            label="Declaración de renta"
            type="file"
            onChange={(e) => {
              setFiles({ ...files, dec_renta: e.target.files[0] });
            }}
            accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          />
        </div>

        <div className="flex items-center justify-center py-3">
          <input
            id="link-checkbox"
            type="checkbox"
            value=""
            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
            required
          />
          <label
            htmlFor="link-checkbox"
            className="ms-2 text-sm font-medium text-white"
          >
            Estoy de acuerdo con los{" "}
            <a href="#" className="text-robin hover:underline">
              términos y condiciones
            </a>
            .
          </label>
        </div>
        {error && <p className="text-primary">{error}</p>}
        {sended && (
          <p className="text-green-400 mb-3">Información enviada con éxito</p>
        )}
        <button
          type="submit"
          className="text-white rounded-lg px-5 py-2.5 text-center bg-richBlack w-full font-bold text-xl"
          disabled={loading}
        >
          {loading ? <Spinner /> : "Enviar información"}
        </button>
      </form>
    </>
  );
}

export default FormStepTwo;
